<template>
    <v-main class="ml-6 mt-3">
        <v-row dense class="ml-1 mt-2">
            <h3>Cancellation Insurance Monthly Report</h3>
        </v-row>
        <v-row class="mt-8 mb-2">
            <div style="width: 10vw" class="ml-4">
                <v-select 
                    v-model="report_params.month" 
                    v-bind:items="months"
                    item-value="code" 
                    item-text="desc" 
                    label="Month"
                    :dense="true" />
            </div>           
            <div style="width: 10vw" class="ml-4">
                <v-select 
                    v-model="report_params.year" 
                    v-bind:items="years"
                    item-value="code" 
                    item-text="desc" 
                    label="Year"
                    :dense="true" />
            </div>                              
        </v-row>
        <v-row class="mb-4">
          <v-checkbox 
            dense
            label="Include testbookings" 
            v-model="report_params.test" 
            class="ml-3">
          </v-checkbox>
        </v-row>
        <v-row class="mt-3 ml-1">
            <btn_create_excel :report_program="report" :report_request="report_request" :report_params="report_params"
                :show_progress="true" @hasError="showError"/>
        </v-row>
        <navBar title="Ares - Finance" :home="true" type="finance" />
        <standard_dialog ref="std_dialog" />    
    </v-main>
</template>
  
<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import btn_create_excel from "@/components/ui/buttons/btn_create_excel.vue";
import standard_dialog from '@/components/ui/standard_dialog.vue';

export default {
    components: {
        navBar,
        btn_create_excel,
        standard_dialog,
    },
    data() {
        return {
            report: "ares/json/ares/task/customer_success/huov/ovrz1.p",
            report_params: {
                month: new Date().getMonth() + 1,
                year: new Date().getFullYear(),
                test: false,
                language: 'EN'
            },
            report_request: "ovrz1",
            months: [
                { code: 1, desc: "January" },
                { code: 2, desc: "February" },
                { code: 3, desc: "March" },
                { code: 4, desc: "April" },
                { code: 5, desc: "May" },
                { code: 6, desc: "June" },
                { code: 7, desc: "July" },
                { code: 8, desc: "August" },
                { code: 9, desc: "September" },
                { code: 10, desc: "October" },
                { code: 11, desc: "November" },
                { code: 12, desc: "December" }
            ],
            years: this.getYearSelection(),
        }
    },
    methods:{
        showError(error){
            this.$refs.std_dialog.open('error', "Error", error.message);    
        },
        getYearSelection(){
            const currentYear = new Date().getFullYear();
            const years = [];
            for (let i = 0; i <= 5; i++) {
                const year = currentYear - i;
                years.push({ code: year, desc: year });
            }
            return years;
        }
    }
}

</script> 

<style scoped>

</style>
  
  
  
  
  